// Bengali offer copy for the prerendered /pricing and /free-credits pages,
// the credit-usage FAQ and the Vectorizer allowance answer. `c` is the
// offer context from appRouteOfferCore.js (catalog prices, credit costs,
// free allowances), so no number is written here by hand.
export const APP_ROUTE_OFFER_COPY_BN = {
  pricing: (c) => ({
    title: 'মূল্য পরিকল্পনা',
    intro: [
      `Stocktag-এর মাসিক ক্রেডিট প্ল্যান ${c.first.name} (${c.first.monthly}-এ ${c.first.credits} ক্রেডিট) থেকে ${c.last.name} (${c.last.monthly}-এ ${c.last.credits} ক্রেডিট) পর্যন্ত। বার্ষিক বিলিংয়ে ${c.discount}% সাশ্রয়; এককালীন প্যাকে ${c.topUpPrice}-এ ${c.topUpCredits} ক্রেডিট।`,
      `ডিফল্ট দ্রুত বিশ্লেষণ স্তরে একটি ছবিতে ${c.fast} ক্রেডিট লাগে। দাম USD-তে দেখানো হয়; পেমেন্টের আগে চেকআউটে আপনার স্থানীয় মুদ্রায় মোট পরিমাণ দেখানো হয়।`
    ],
    bullets: [
      `${c.planCount}টি মাসিক ক্রেডিট প্ল্যান, মাসে ${c.first.credits} থেকে ${c.last.credits} ক্রেডিট`,
      `বার্ষিক বিলিংয়ে ${c.discount}% সাশ্রয়, তবুও প্রতি মাসে ক্রেডিট যোগ হয়`,
      `এককালীন প্যাক: ${c.topUpPrice}-এ ${c.topUpCredits} ক্রেডিট, কোনো মেয়াদ নেই`,
      `ডিফল্ট দ্রুত বিশ্লেষণে প্রতি ছবিতে ${c.fast} ক্রেডিট থেকে শুরু`
    ],
    links: [
      { href: '/metadata', label: 'Metadata Studio চেষ্টা করুন' },
      { href: '/free-credits', label: 'বিনামূল্যে ক্রেডিট নিন' },
      { href: '/help', label: 'মূল্য সংক্রান্ত FAQ' }
    ],
    sections: [
      {
        title: 'মাসিক ক্রেডিট প্ল্যান ও দাম',
        paragraphs: [
          'প্রতি মাসে কত ক্রেডিট যোগ হয়, সেটাই প্ল্যানগুলোর মূল পার্থক্য। সাবস্ক্রিপশন ক্রেডিট প্রতি মাসে নবায়ন হয়; অব্যবহৃত সাবস্ক্রিপশন ক্রেডিট পরের মাসে যোগ হয় না।'
        ],
        bullets: c.plans.map((plan) => (plan.yearly
          ? `${plan.name}: মাসে ${plan.credits} ক্রেডিট, মাসিক ${plan.monthly} অথবা বার্ষিক ${plan.yearly} (মাসে ${plan.yearlyPerMonth})`
          : `${plan.name}: মাসে ${plan.credits} ক্রেডিট, মাসিক ${plan.monthly}`))
      },
      {
        title: 'বার্ষিক বিলিং',
        paragraphs: [
          `বার্ষিক পেমেন্টে বারোটি মাসিক পেমেন্টের চেয়ে ${c.discount}% কম খরচ হয়। বছরে একবার বিল হয়, আর প্ল্যানের ক্রেডিট প্রতি মাসেই যোগ হয়।`
        ]
      },
      {
        title: 'এককালীন ক্রেডিট প্যাক',
        paragraphs: [
          `একবার পেমেন্ট করে ${c.topUpPrice}-এ ${c.topUpCredits} ক্রেডিট কিনুন। কেনা ক্রেডিটের কোনো মেয়াদ নেই, সাবস্ক্রিপশন ছাড়াও ব্যবহার করা যায় এবং সক্রিয় প্ল্যানের ক্রেডিটের সঙ্গে যোগ হয়।`
        ]
      },
      {
        title: 'এক ক্রেডিটে কী পাওয়া যায়',
        paragraphs: [
          'আপনার বেছে নেওয়া বিশ্লেষণ স্তর অনুযায়ী প্রতিটি ফাইলে ক্রেডিট কাটা হয়। ডিফল্ট স্তর হলো দ্রুত বিশ্লেষণ।'
        ],
        bullets: [
          `দ্রুত বিশ্লেষণ: প্রতি ছবিতে ${c.fast} ক্রেডিট (ডিফল্ট)`,
          `স্ট্যান্ডার্ড বিশ্লেষণ: প্রতি ছবিতে ${c.standard} ক্রেডিট`,
          `গভীর বিশ্লেষণ: প্রতি ছবিতে ${c.deep} ক্রেডিট`,
          `ভিডিও: প্রতি ${c.videoSeconds} সেকেন্ডে 1 ক্রেডিট, পূর্ণসংখ্যায় উপরের দিকে রাউন্ড করা হয়, প্রতি ক্লিপে সর্বোচ্চ ${c.maxVideoSeconds} সেকেন্ড`,
          `উদাহরণ: ${c.example.name} প্ল্যানের মাসিক ${c.example.credits} ক্রেডিটে দ্রুত বিশ্লেষণে প্রায় ${c.example.fast}টি, স্ট্যান্ডার্ডে ${c.example.standard}টি বা গভীর বিশ্লেষণে ${c.example.deep}টি ছবি প্রসেস করা যায়`
        ]
      }
    ],
    faq: [
      {
        q: 'Stocktag-এর খরচ কত?',
        a: `মাসিক প্ল্যান শুরু হয় ${c.first.name} দিয়ে: ${c.first.monthly}-এ ${c.first.credits} ক্রেডিট। সবচেয়ে বড় প্ল্যান ${c.last.name}: ${c.last.monthly}-এ ${c.last.credits} ক্রেডিট। বার্ষিক বিলিংয়ে ${c.discount}% সাশ্রয় হয়, আর ${c.topUpCredits} ক্রেডিটের এককালীন প্যাকের দাম ${c.topUpPrice}। দাম USD-তে; চেকআউটে আপনার স্থানীয় মুদ্রায় মোট পরিমাণ দেখানো হয়।`
      },
      'creditUsage',
      {
        q: 'ক্রেডিটের কি মেয়াদ শেষ হয়?',
        a: 'সাবস্ক্রিপশন ক্রেডিট প্রতি মাসে নবায়ন হয় এবং অব্যবহৃত সাবস্ক্রিপশন ক্রেডিট পরের মাসে যোগ হয় না। এককালীন প্যাকের ক্রেডিটের কোনো মেয়াদ নেই।'
      },
      {
        q: 'Stocktag কি বিনামূল্যে চেষ্টা করা যায়?',
        a: `হ্যাঁ। যোগ্য নতুন অ্যাকাউন্ট ${c.welcome}টি বিনামূল্যে ক্রেডিট পায়, আর হোমপেজের গেস্ট ডেমো সাইন আপ ছাড়াই একটি ছবির নমুনা ফলাফল তৈরি করে।`
      },
      {
        q: 'বার্ষিক প্ল্যানে কি সব ক্রেডিট একবারে যোগ হয়?',
        a: 'না। বার্ষিক প্ল্যানে বছরে একবার বিল হয় এবং প্ল্যানের ক্রেডিট প্রতি মাসে যোগ হয়।'
      }
    ]
  }),
  creditUsageFaq: (c) => ({
    q: 'একটি ছবিতে কত ক্রেডিট লাগে?',
    a: `ডিফল্ট দ্রুত বিশ্লেষণে একটি ছবিতে ${c.fast} ক্রেডিট, স্ট্যান্ডার্ড বিশ্লেষণে ${c.standard} ক্রেডিট এবং গভীর বিশ্লেষণে ${c.deep} ক্রেডিট লাগে। ভিডিওতে প্রতি ${c.videoSeconds} সেকেন্ডে 1 ক্রেডিট লাগে।`
  }),
  freeCredits: (c) => ({
    title: 'বিনামূল্যে ক্রেডিট',
    intro: [
      `যোগ্য নতুন অ্যাকাউন্ট ${c.welcome}টি বিনামূল্যে ক্রেডিট পায়, আর প্রতিটি যোগ্য রেফারেলে আপনি পান ${c.referral} ক্রেডিট। নিজের স্টক ছবিতে টাইটেল, বর্ণনা ও কীওয়ার্ড পরীক্ষা করুন।`,
      `ডিফল্ট দ্রুত বিশ্লেষণ স্তরে ${c.welcome} ক্রেডিটে ${c.welcomeImages}টি ছবি প্রসেস করা যায়। অ্যাকাউন্ট খোলার আগে ফলাফল দেখতে চান? হোমপেজের গেস্ট ডেমো সাইন আপ ছাড়াই একটি ছবি প্রসেস করে।`
    ],
    bullets: [
      `যোগ্য নতুন অ্যাকাউন্টে ${c.welcome}টি বিনামূল্যে ক্রেডিট`,
      `প্রতিটি যোগ্য রেফারেলে ${c.referral} ক্রেডিট`,
      'একটি ছবির জন্য বিনামূল্যে গেস্ট ডেমো, সাইন আপ লাগে না',
      `Vectorizer: সাইন ইন করলে দিনে ${c.vectorFree}টি ছবি বিনামূল্যে`
    ],
    links: [
      { href: '/pricing', label: 'মূল্যের বিবরণ' },
      { href: '/metadata', label: 'মেটাডেটা ওয়ার্কফ্লো শুরু করুন' },
      { href: '/help', label: 'ক্রেডিট কীভাবে কাজ করে' }
    ],
    sections: [
      {
        title: 'ওয়েলকাম ক্রেডিট কীভাবে কাজ করে',
        paragraphs: [
          `একটি অ্যাকাউন্ট খুলুন এবং সাইনআপ যাচাই সম্পন্ন করুন। যোগ্য নতুন অ্যাকাউন্ট ${c.welcome} ক্রেডিট পায়, যা ডিফল্ট দ্রুত বিশ্লেষণে ${c.welcomeImages}টি ছবির জন্য যথেষ্ট।`
        ],
        bullets: [
          'Metadata Studio-তে টাইটেল, বর্ণনা ও কীওয়ার্ড তৈরিতে ব্যবহার করুন',
          `দ্রুত বিশ্লেষণে প্রতি ছবিতে ${c.fast}, স্ট্যান্ডার্ডে ${c.standard} এবং গভীর বিশ্লেষণে ${c.deep} ক্রেডিট লাগে`,
          'ফলাফল যাচাই করে আপনার মার্কেটপ্লেসের জন্য CSV বা XMP এক্সপোর্ট করুন'
        ]
      },
      {
        title: 'রেফার করে ক্রেডিট আয় করুন',
        paragraphs: [
          `এই পেজ থেকে আপনার ব্যক্তিগত রেফারেল লিংক শেয়ার করুন। কেউ সেই লিংক দিয়ে অ্যাকাউন্ট খুলে প্রয়োজনীয় যাচাই পার হলে আপনি স্বয়ংক্রিয়ভাবে ${c.referral} ক্রেডিট পাবেন।`
        ],
        bullets: [
          'বিনামূল্যে ক্রেডিট পেজ থেকে লিংক কপি বা শেয়ার করুন',
          'মোট রেফারেল এবং অর্জিত ক্রেডিট দেখুন',
          'প্রতিটি যোগ্য নতুন অ্যাকাউন্টের জন্য পুরস্কার একবারই দেওয়া হয়'
        ]
      },
      {
        title: 'পরীক্ষার সেরা উপায়',
        paragraphs: [
          'আপনার কাজের প্রতিনিধিত্বমূলক একটি ব্যাচ চালান এবং কীওয়ার্ডের ক্রম, বর্ণনা ও এক্সপোর্ট ফরম্যাট যাচাই করে দেখুন ওয়ার্কফ্লো আপনার পোর্টফোলিওর সঙ্গে কতটা মানানসই।'
        ],
        bullets: [
          'একাধিক মার্কেটপ্লেসে পরীক্ষা করুন',
          'সার্চ ইনটেন্ট অনুযায়ী কীওয়ার্ড সেট তুলনা করুন',
          'CSV বা XMP এক্সপোর্ট যাচাই করুন'
        ]
      }
    ],
    faq: [
      {
        q: 'বিনামূল্যে ক্রেডিট কীভাবে পাব?',
        a: `একটি Stocktag অ্যাকাউন্ট খুলুন। যোগ্য নতুন অ্যাকাউন্ট সাইনআপের পর ${c.welcome} ক্রেডিট পায়, আর প্রতিটি যোগ্য রেফারেলের জন্য আপনি ${c.referral} ক্রেডিট পান।`
      },
      {
        q: 'সাইন আপ না করে কি Stocktag চেষ্টা করা যায়?',
        a: 'হ্যাঁ। হোমপেজের গেস্ট ডেমো অ্যাকাউন্ট ছাড়াই প্রতি 24 ঘণ্টায় একবার একটি ছবির নমুনা মেটাডেটা ফলাফল তৈরি করে। ফলাফল তৈরির জন্য ছবিটি Stocktag-এর গেস্ট মেটাডেটা সার্ভিসে পাঠানো হয়।'
      },
      {
        q: 'বিনামূল্যে ক্রেডিট শেষ হলে কী করব?',
        a: `${c.first.monthly}-এ ${c.first.credits} ক্রেডিট দিয়ে শুরু হওয়া মাসিক প্ল্যান বেছে নিন, অথবা ${c.topUpPrice}-এ ${c.topUpCredits} ক্রেডিটের এককালীন প্যাক কিনুন। এককালীন ক্রেডিটের কোনো মেয়াদ নেই।`
      },
      'creditUsage'
    ]
  }),
  vectorizerAllowance: (c) => `হ্যাঁ। একটি ফাইল বা পুরো ব্যাচ রূপান্তর করতে পারেন। সাইন ইন করা অ্যাকাউন্ট দিনে ${c.vectorFree}টি ছবি বিনামূল্যে ভেক্টরে রূপান্তর করতে পারে; এর বেশি প্রতিটি ছবিতে ${c.vectorPaid} ক্রেডিট লাগে।`
};

export default APP_ROUTE_OFFER_COPY_BN;
